/* jshint esversion: 6 */
import GtmService from '../gtm/gtm.service';

export default class ShareDirective {

	constructor(
		$timeout
	) {
		this.$timeout = $timeout;
		this.restrict = 'A'; this.template = (element, attributes) => {
			let template = `
			<div role="button" tabindex="0" class="btn btn--facebook" ng-click="onFacebook()" ng-keydown="onKeyDown($event, 'facebook')">
				<svg class="icon icon--facebook"><use xlink:href="#icon--facebook"></use></svg>
			</div>
			<div role="button" tabindex="0" class="btn btn--linkedin" ng-click="onLinkedin()" ng-keydown="onKeyDown($event, 'linkedin')">
				<svg class="icon icon--linkedin"><use xlink:href="#icon--linkedin"></use></svg>
			</div>
			<div role="button" tabindex="0" class="btn btn--pinterest" ng-click="onPinterest()" ng-keydown="onKeyDown($event, 'pinterest')">
				<svg class="icon icon--pinterest"><use xlink:href="#icon--pinterest"></use></svg>
			</div>`; if (attributes.shareToggle !== undefined) {
				template += `
				<div role="button" tabindex="0" class="btn btn--remove" ng-click="onRemove()" ng-keydown="onKeyDown($event, 'remove')">
					<svg class="icon icon--remove"><use xlink:href="#icon--remove"></use></svg>
				</div>`
			}
			return template;
		};
		this.scope = {
			item: '=?share',
		};
	}

	link(scope, element, attributes, controller) {
		scope.item = scope.item || {};
		const node = element[0];
		const img = node.querySelector('img');
		let pageSrc = scope.item.src;
		let nomecontenuto = scope.item.nomecontenuto + '';
		let label = scope.item.label;
		let position = scope.item.position;
		let eventname = scope.item.eventname;
		let pageTitle = scope.item.title || document.title;
		if (img) {
			pageSrc = img.src;
			pageTitle = img.title || pageTitle;
		}
		const pageUrl = scope.item.url || `${window.location.href}?imageId=${scope.item.id}`;
		scope.onFacebook = (event) => {
			const obj = Object.assign({}, window.objDataLayerInfo);
			obj["eventname"] = eventname;
			obj["position"] = position ?? "share_facebook";
			obj["label"] = label ?? "facebook";
			obj["nomecontenuto"] = nomecontenuto;
			GtmService.push(obj);
			//console.log('ShareDirective.onFacebook', event);

			const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`;
			window.open(url, 'facebookShareWindow', `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${window.innerWidth / 2 - 225}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`);
			// event.preventDefault();
		};
		scope.onLinkedin = (event) => {
			const obj = Object.assign({}, window.objDataLayerInfo);
			obj["eventname"] = eventname;
			obj["position"] = position ?? "share_linkedin";
			obj["label"] = label ?? "linkedin";
			obj["nomecontenuto"] = nomecontenuto;
			GtmService.push(obj);
			//console.log('ShareDirective.onLinkedin', event);
			const url = `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(pageUrl)}&via=LeaCeramiche&text=${encodeURIComponent(pageTitle)}`;
			window.open(url, 'linkedinShareWindow', `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${window.innerWidth / 2 - 225}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`);
			// event.preventDefault();
		};
		scope.onTwitter = (event) => {
			// console.log('ShareDirective.onTwitter', event);
			const obj = Object.assign({}, window.objDataLayerInfo);
			obj["eventname"] = eventname;
			obj["position"] = position ?? "share_twitter";
			obj["label"] = label ?? "twitter";
			obj["nomecontenuto"] = nomecontenuto;
			GtmService.push(obj);
			const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}&via=LeaCeramiche&text=${encodeURIComponent(pageTitle)}`;
			window.open(url, 'twitterShareWindow', `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${window.innerWidth / 2 - 225}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`);
			// event.preventDefault();
		}; scope.onPinterest = () => {
			const pin = {
				url: pageUrl,
				media: pageSrc,
				description: pageTitle,
			};
			const obj = Object.assign({}, window.objDataLayerInfo);
			obj["eventname"] = eventname;
			obj["position"] = position ?? "share_pinterest";
			obj["label"] = label ?? "pinterest";
			obj["nomecontenuto"] = nomecontenuto;;
			GtmService.push(obj);
			// console.log('ShareDirective.onPin', pin);
			PinUtils.pinOne(pin);
		};

		scope.onRemove = () => {
			// Chiude il pannello di share
			scope.$parent.root.share = false;
		};

		scope.onKeyDown = (event, action) => {
			if (event.key === 'Enter') {
				event.preventDefault();
				event.stopPropagation();
				switch (action) {
					case 'facebook':
						scope.onFacebook(event);
						break;
					case 'linkedin':
						scope.onLinkedin(event);
						break;
					case 'pinterest':
						scope.onPinterest(event);
						break;
					case 'remove':
						scope.onRemove();
						break;
				}
			}
		};

		scope.$on('$destroy', () => { });
	}

	static factory($timeout) {
		return new ShareDirective($timeout);
	}

}

ShareDirective.factory.$inject = ['$timeout'];
